import details from "./details"
import membership from "./membership"

const reducers = {
  details,
  membership,
}

export default reducers
